import React, {FC} from 'react';
import {Property} from "../../../models/Property";
import {Card, CardContent as MuiCardContent, CardMedia, Theme, Typography, useMediaQuery} from "@mui/material";
import {getTextByCurrentLanguage} from "../../../utils/language";
import {getPropertyGeneralImage} from "../../../utils/images";
import styled from "styled-components";

const CardContent = styled(MuiCardContent)`
  padding-bottom: 16px !important;
  
  p {
    font-size: 14px !important; 
    font-weight: 500;
  }
`

type TypeProps = {
    onClick: (propertyId: string) => void
}

const Item: FC<Property & TypeProps> = ({ id, name, general_image, general_image_thumbnails, onClick }) => {
    const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

    return (
        <Card variant="outlined" onClick={() => onClick(id)}>
            <CardMedia
                sx={{ height: sm ? 170 : 150 }}
                image={getPropertyGeneralImage({general_image, general_image_thumbnails}, 'small')}
                title={getTextByCurrentLanguage(name)}
            />
            <CardContent>
                <Typography>{getTextByCurrentLanguage(name)}</Typography>
            </CardContent>
        </Card>
    );
};

export default Item;